import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ProductTypeSelectorComponent } from "../../shared/product-type-selector/product-type-selector.component";
import { RecordingService } from "../../services/recording.service";
import { ProductTypeService } from "../../services/product-type.service";
import { ProductType } from "../../models/product-type.model";
import { map, switchMap, take } from "rxjs/operators";

export interface RecordingApproveModalData {
  recordingName: string;
  recordingId: number;
  stationId: number;
}

export interface RecordingApproveModalResult {
  success: true;
  product_type_ids: number[];
  productTypes: ProductType[];
}

@Component({
  selector: "app-recording-approve-modal",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    ProductTypeSelectorComponent,
  ],
  templateUrl: "./recording-approve-modal.component.html",
  styleUrls: ["./recording-approve-modal.component.css"],
})
export class RecordingApproveModalComponent {
  recordingName: string;
  selectedProductTypeIds: number[] = [];
  productTypeError = "";
  submitError = "";
  sending = false;

  constructor(
    public dialogRef: MatDialogRef<RecordingApproveModalComponent, RecordingApproveModalResult | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: RecordingApproveModalData,
    private recordingService: RecordingService,
    private productTypeService: ProductTypeService,
  ) {
    this.recordingName = data?.recordingName ?? "";
  }

  onProductTypesChange(ids: number[]): void {
    this.selectedProductTypeIds = ids;
    if (ids.length > 0) {
      this.productTypeError = "";
    }
  }

  submit(): void {
    if (this.sending) return;
    if (this.selectedProductTypeIds.length === 0) {
      this.productTypeError = "Please assign at least one product type";
      return;
    }

    this.sending = true;
    this.submitError = "";
    this.dialogRef.disableClose = true;

    this.productTypeService.getProductTypes().pipe(
      take(1),
      switchMap((catalog) =>
        this.recordingService
          .approve(this.data.recordingId, this.data.stationId, this.selectedProductTypeIds)
          .pipe(
            map(() => catalog.filter((pt) => this.selectedProductTypeIds.includes(pt.id))),
          ),
      ),
    ).subscribe({
      next: (productTypes) => {
        this.dialogRef.close({
          success: true,
          product_type_ids: this.selectedProductTypeIds,
          productTypes,
        });
      },
      error: (err) => {
        this.sending = false;
        this.dialogRef.disableClose = false;
        this.submitError =
          err?.error?.error || err?.error?.message || "Failed to approve recording. Please try again.";
      },
    });
  }
}
